import { type ComponentType } from 'react'
import { FileCheck2, Home, Megaphone, Store } from 'lucide-react'

export const OWNER_PATH = {
  home: '/owner/home',
  myStore: '/owner/mystore',
  myStoreChange: '/owner/mystore/change',
  notice: '/owner/notice',
  docs: '/owner/docs',
} as const

/** 점주 홈 상단 바로가기 타일. 첫 항목만 서비스 색, 나머지는 중립색.
 * 정보변경은 마이스토어 안, 공지사항은 홈 공지 카드에서 들어간다. */
export const OWNER_MENU: {
  name: string
  label: string
  icon: ComponentType<{ className?: string; 'aria-hidden'?: boolean }>
  path: string
}[] = [
  { name: '마이스토어', label: '우리 매장 정보', icon: Store, path: OWNER_PATH.myStore },
  { name: '법정서류', label: '기한 관리', icon: FileCheck2, path: OWNER_PATH.docs },
]

/** 햄버거 메뉴 목록 */
export const OWNER_NAV: {
  group: string
  items: { ko: string; icon: (typeof OWNER_MENU)[number]['icon']; path: string }[]
}[] = [
  { group: '홈', items: [{ ko: '홈', icon: Home, path: OWNER_PATH.home }] },
  {
    group: '매장 관리',
    items: OWNER_MENU.map((menu) => ({ ko: menu.name, icon: menu.icon, path: menu.path })),
  },
  { group: '더보기', items: [{ ko: '공지사항', icon: Megaphone, path: OWNER_PATH.notice }] },
]

const TITLES: [string, string][] = [
  [OWNER_PATH.myStoreChange, '정보변경 요청'],
  [OWNER_PATH.myStore, '마이스토어'],
  [OWNER_PATH.notice, '공지사항'],
  [OWNER_PATH.docs, '법정서류'],
  [OWNER_PATH.home, '홈'],
]

export function titleForPath(pathname: string) {
  return TITLES.find(([path]) => pathname.startsWith(path))?.[1]
}

/** 헤더 뒤로가기 목적지. 홈이면 undefined (뒤로가기 없음). */
export function parentPathFor(pathname: string) {
  if (pathname.startsWith(OWNER_PATH.myStoreChange)) return OWNER_PATH.myStore
  if (pathname.startsWith(`${OWNER_PATH.docs}/`)) return OWNER_PATH.docs
  if (pathname.startsWith(`${OWNER_PATH.notice}/`)) return OWNER_PATH.notice
  if (pathname.startsWith(OWNER_PATH.home)) return undefined
  return OWNER_PATH.home
}
